import styled from "styled-components";
import { responsive } from "../../../../../styles/constants.style";

export const GenericAccountsSearchHeaderWrapper = styled.div`
  margin: 4px 0px 16px;
  .info-box-wrapper { 
    ${responsive.MOBILE`
      padding-bottom: 0;
    `}
  }
  .header-right {
    text-align: end;
    margin-top: 16px;

    .header-right-button {
      ${responsive.MOBILE`
        width: 100%;
        margin-bottom: 0;
      `}
    }
  }
`;
